<template>
  <div class="mt-4">
    <v-card-text>
      <v-row v-if="!is_second_step">
        <v-col cols="12" md="4">
          <v-select
            v-if="$router.currentRoute.name==='new-job-order'"
            v-model="type_of_service"
            class="mb-4"
            dense
            outlined
            label="Type"
            :items="['WALK-IN','REFERRAL','CALL']"
            :rules="rules.combobox_rule"
          ></v-select>
          <v-select
            v-if="$router.currentRoute.name==='add-new-job-order'"
            :items="table_items"
            item-value="travel_order_no"
            item-text="travel_order_no"
            label="Job Order #"
            required
            :rules="rules.combobox_rule"
            v-model="travel_order_no"
            dense
            outlined
          ></v-select>
        </v-col>
        <v-col cols="12" md="4">
          <v-text-field
            v-if="$router.currentRoute.name==='new-job-order'"
            v-model="purpose"
            outlined
            label="Purpose"
            placeholder="NA"
            :rules="rules.non_empty_field_rule"
            dense
            required
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="4">
          <v-combobox
            v-if="$router.currentRoute.name==='new-job-order'"
            :append-icon="icons.mdiAccountSearchOutline"
            v-model="search"
            @keyup.enter="searching($event.target.value)"
            @change="get_search_items_info"
            :items="search_items"
            item-value="id"
            item-text="company_name"
            placeholder="Search by (Account Name/Account #)"
            ref="memberCombobox"
            dense
            outlined
          ></v-combobox>
          <v-text-field
            v-else
            v-model="name_of_customer"
            outlined
            label="Name of Customer"
            placeholder="JUAN DELA CRUZ"
            :rules="rules.non_empty_field_rule"
            dense
            required
            readonly
          ></v-text-field>
        </v-col>
        <v-btn
          v-if="travel_order_no==='' && $router.currentRoute.name==='new-job-order'"
          class="w-full"
          color="info"
          @click="generate_travel_order()"
        >
          Generate Job Order
        </v-btn>
      </v-row>
    </v-card-text>
    <snack-bar-dialog :snackbar_flag="this.snackbar" :color="this.snackbar_color"
                      :snackbar_text="this.snackbar_text"/>
  </div>
</template>

<script>
import {mdiAlertOutline, mdiCloudUploadOutline, mdiAccountSearchOutline} from '@mdi/js'
import {mapGetters, mapActions} from 'vuex'
import moment from 'moment'
import snackBarDialog from '@/components/dialogs/notifications_dialog/Snackbar'

const initialState = () => {
  return {
    search: '',
    search_member: '',
    search_items: [],
    keyyy: 0,
    member_information: {},

    saving: false,
    alert: false,
    alert_message: '',

    purpose: '',
    travel_order_no: '',
    type_of_service: '',
    name_of_customer: '',
    customer: {},
    table_items: [],
  }
}
export default {
  props: {
    is_second_step: Boolean,
  },
  components: {
    snackBarDialog,
  },
  setup() {
    return {
      icons: {
        mdiAlertOutline,
        mdiCloudUploadOutline,
        mdiAccountSearchOutline,
      },
    }
  },
  data() {
    return initialState()
  },
  watch: {
    search_member: function () {
      if (this.timeout) clearTimeout(this.timeout)
      this.timeout = setTimeout(() => {
        if (this.search_member === '') {
          this.search_items = []
        } else {
          this.searching_search_items(this.search_member)
        }
        this.member_information = {}
        this.induction_history = []
      }, 500)
    },
    travel_order_no: function () {
      switch (this.$router.currentRoute.name) {
        case 'new-job-order':
          // this.$emit('data', {
          //   travel_order_no: this.travel_order_no,
          //   type_of_service: this.type_of_service,
          //   purpose: this.purpose,
          //   name_of_customer: this.name_of_customer,
          //   customer: this.customer,
          // })
          break
        case 'add-new-job-order':
          this.name_of_customer = this.table_items[this.table_items.map(function (x) {
            return x.travel_order_no;
          }).indexOf(this.travel_order_no)].name_of_customer;
          this.customer = this.table_items[this.table_items.map(function (x) {
            return x.travel_order_no;
          }).indexOf(this.travel_order_no)].customer;
          this.type_of_service = this.table_items[this.table_items.map(function (x) {
            return x.travel_order_no;
          }).indexOf(this.travel_order_no)].type_of_service;
          this.purpose = this.table_items[this.table_items.map(function (x) {
            return x.travel_order_no;
          }).indexOf(this.travel_order_no)].purpose;
          this.$emit('data', {
            travel_order_no: this.travel_order_no,
            type_of_service: this.type_of_service,
            name_of_customer: this.name_of_customer,
            customer: this.customer,
          })
          break
      }
    },
    name_of_customer: function () {
      this.$emit('data', {
        travel_order_no: this.travel_order_no,
        type_of_service: this.type_of_service,
        purpose: this.purpose,
        name_of_customer: this.name_of_customer,
      })
    },
    type_of_service: function () {
      this.$emit('data', {
        travel_order_no: this.travel_order_no,
        type_of_service: this.type_of_service,
        purpose: this.purpose,
        name_of_customer: this.name_of_customer,
      })
    },
    purpose: function () {
      this.$emit('data', {
        travel_order_no: this.travel_order_no,
        type_of_service: this.type_of_service,
        purpose: this.purpose,
        name_of_customer: this.name_of_customer,
      })
    },
  },
  mounted() {
    switch (this.$router.currentRoute.name) {
      case 'new-job-order':
        // this.get_available_table({
        //   branch_id: this.branch_id,
        // })
        //   .then(response => {
        //     this.table_items = response.data
        //   })
        //   .catch(error => {
        //     console.log(error)
        //   })
        break
      case 'add-new-job-order':
        this.get_available_table_not_yet_paid({
          branch_id: this.branch_id,
        })
          .then(response => {
            this.table_items = response.data
          })
          .catch(error => {
            console.log(error)
          })
        break
    }
  },
  computed: {
    ...mapGetters('form_rules', ['rules']),
    ...mapGetters('system_data', ['snackbar', 'snackbar_color', 'snackbar_text']),
    ...mapGetters('authentication', ['user_id', 'branch_id']),
  },
  methods: {
    ...mapActions('system_data', ['change_snackbar']),
    ...mapActions('table', ['register_table', 'get_available_table', 'get_available_table_not_yet_paid']),
    ...mapActions('customer', ['search_customer']),
    searching(value) {
      this.keyyy++;
      this.search_member = value
    },
    searching_search_items(value) {
      this.search_customer({
        search_word: value,
      })
        .then(response => {
          this.search_items = response.data
        })
    },
    reset() {
      this.member_information = {}
    },
    get_search_items_info() {
      this.keyyy++;
      this.member_information = {}
      if (this.search_items.length > 0) {
        var index = this.search_items.map(function (x) {
          return x.id;
        }).indexOf(this.search.id)
        if (index != -1) {
          this.member_information = this.search_items[index]
        } else {
          this.reset()
        }
      } else {
        this.reset()
      }
    },
    async generate_travel_order() {
      await this.register_table({
        customer_id: this.member_information.id,
        type_of_service: this.type_of_service,
        purpose: this.purpose,
        branch_id: this.branch_id,
      })
        .then(response => {
          this.change_snackbar({
            show: true,
            color: response.status === 200 ? 'success' : 'error',
            text: 'JOB ORDER # ' + response.data.travel_order_no + ' IS NOW CREATED!',
          })
          this.$emit('job_order', response.data)
        })
      // location.reload()
    },
  },
}
</script>
